import WINDOW from "../../../utils/window";
import getParentMap from "./get-parent-map";

/**
 * Set user-defined initial properties into the `main.initials`
 * @example `translateX(2rem) background-color(rgba(0,0,0,0.5))`
 * @param {PropertyWrapperProps} data
 * @param {MainClassProps | null} main
 * @param {StepProps} step
 * @param {Boolean} isDefault
 */
const setInitialProperties = (data, main, step, isDefault) => {
  if (!main) {
    return;
  }

  const properties =
    /** @type {Map<String, any>} */ (getParentMap(data, main, step, null)) ||
    new Map();

  for (const [name, values] of properties) {
    if (!main.initials.has(name)) {
      main.initials.set(name, new Map());
    }

    for (const [key, value] of values) {
      value.set("is-safari-initial", isDefault && WINDOW.get("is-safari"));
      main.initials.get(name).set(key, value);
    }
  }
};

export default setInitialProperties;
